import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasLayerToolbarActionClicked.meta';

export type UseTrackCanvasLayerToolbarActionClickedParams = {
  canvas_id: string;
  action_taken: 'edit_text' | 'duplicate' | 'prompt' | 'remove_background' | 'delete';
};

export const useTrackCanvasLayerToolbarActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasLayerToolbarActionClicked = useCallback(
    (params: UseTrackCanvasLayerToolbarActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasLayerToolbarActionClicked };
};
